import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useFpB2bPaymentService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-payment-service'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useApiGetFpPayment } from '@hooks-api/fortune/useApiGetFpPayment'
import { PaymentMethodType, PaymentServiceType } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { AliPay } from '@pets-ui/icons'
import { Radio } from '@pets-ui/Radio/Radio'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useContextPayment } from '../../../../fp-b2b-shared/components/PaymentProvider/PaymentProvider'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { paymentComponentStyle } from './PaymentMethodComponent'

export const PaymentAliPay = () => {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { trigger: getPaymentToken } = useApiGetFpPayment()
  const { selectedPayment, setSelectedPayment, paymentMethods, setPaymentExecution, getActivePaymentModuleB2B, setConfiguredPaymentModule, isSdkInitialized, setIsLoadingPayment, isProcessingCheckout } = useContextPayment()
  const { campaignId, platform } = useCheckout()

  const checked = selectedPayment?.service_type === PaymentServiceType.CHECKOUTPAY && selectedPayment.type === PaymentMethodType.ALIPAY_HK
  const currentMethod = paymentMethods.find(method => method.service_type === PaymentServiceType.CHECKOUTPAY && method.type === PaymentMethodType.ALIPAY_HK)
  const paymentModule = getActivePaymentModuleB2B(PaymentServiceType.CHECKOUTPAY, PaymentMethodType.ALIPAY_HK)

  const { transactionId: paymentTransactionIdFromUrl } = useParams<{ transactionId?: string }>()
  const { orderId, orderType } = useFpB2bPaymentService({ campaignId, paymentTransactionIdFromUrl, campaignCode: campaignCodeFromUrl, platform })
  const handleSelectPayment = useCallbackEvent(async () => {
    try {
      if (!campaignCodeFromUrl) {
        throw new Error('Missing campaign code')
      }
      if (!currentMethod) {
        throw new Error('Missing payment method')
      }
      setSelectedPayment(currentMethod)

      setIsLoadingPayment(true)
      const token = await getPaymentToken({
        order_type: orderType,
        order_id: orderId,
        payment_method_id: currentMethod.id,
      })

      const { payment_transaction_id } = token.data.data
      setPaymentExecution({
        payment_transaction_id,
        service_pay_info: null,
        user_payment_token_info: undefined,
        payment_success_url: '',
        payment_fallback_url: '',
      })
      // 送出後在彈窗內 applyCkoSession（含 appKey / session / mount），這裡只需指定模組。
      setConfiguredPaymentModule(paymentModule)
    }
    catch (error) {
      console.error(`[PaymentAliPayHK] ${error}`)
    }
    finally {
      setIsLoadingPayment(false)
    }
  })

  const handleInitPayment = useCallback(async () => {
    // NOTE: isSdkInitialized promises that the payment module is init after sdk init
    const shouldInit = selectedPayment?.service_type === PaymentServiceType.CHECKOUTPAY && selectedPayment.type === PaymentMethodType.ALIPAY_HK && isSdkInitialized
    if (!shouldInit) return
    handleSelectPayment()
  }, [handleSelectPayment, isSdkInitialized, selectedPayment?.service_type, selectedPayment?.type])

  // NOTE: init for default payment
  useEffect(() => {
    handleInitPayment()
  }, [handleInitPayment])

  return (
    <Box component="label" rootStyle={[paymentComponentStyle.root, paymentComponentStyle.radioPaymentChecked]}>
      <VStack flexGrow={1} gap={2.5}>
        <HStack alignItems="center" gap={2}>
          <Radio
            name="aliPayHK"
            checked={checked}
            value="aliPayHK"
            onChange={handleSelectPayment}
            disabled={isProcessingCheckout}
          />
          <AliPay />
          <Text fontWeight={600} lineHeight="100%">AliPayHK</Text>
          <Box flexGrow={1} />
          {/* endIcon */}
        </HStack>
      </VStack>
    </Box>
  )
}
